import httpClient from "../../../client/httpClient";

const fetchRefundCounts = async (signal) => {
    const baseRequestBody = {
        pageNumber: 1,
        pageSize: 1,
        sortBy: "id",
        sortOrder: "DESC",
        filters: {}
    };

    const countRequests = [
        { key: "all", orderStatuses: "PENDING_REFUND,REFUND" },
        { key: "pending", orderStatuses: "PENDING_REFUND" },
        { key: "refunded", orderStatuses: "REFUND" }
    ];

    const createRequest = (orderStatuses) =>
        httpClient.post("/v1/api/customer-order/admin/refund-status", baseRequestBody, {
            params: { orderStatuses },
            signal
        });

    try {
        const responses = await Promise.all(
            countRequests.map(({ orderStatuses }) => createRequest(orderStatuses))
        );

        return countRequests.reduce((acc, { key }, index) => {
            acc[key] = responses[index].data.totalElements ?? 0;
            return acc;
        }, {});
    } catch (error) {
        console.error("Error on fetching refund counts", error);
        throw error;
    }
};

export const fetchRefunds = async (payload = {}, signal) => {
    const {
        filters = {
            fromDate: "",
            toDate: "",
            orderNumber: "",
            refundStatus: "all"
        },
        pagination = { page: 1, pageSize: 10 },
        sorting = { sortBy: "id", sortOrder: "DESC" }
    } = payload;

    const getOrderStatuses = (refundStatus) => {
        switch (refundStatus) {
            case "all":
                return "PENDING_REFUND,REFUND";
            case "pending":
                return "PENDING_REFUND";
            case "refunded":
                return "REFUND";
            default:
                return "PENDING_REFUND,REFUND";
        }
    };

    const formatDateForApi = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const queryParams = {
        orderStatuses: getOrderStatuses(filters.refundStatus)
    };

    if (filters.fromDate) {
        queryParams.fromDate = formatDateForApi(filters.fromDate);
    }
    if (filters.toDate) {
        queryParams.toDate = formatDateForApi(filters.toDate);
    }

    if (filters.orderNumber) {
        queryParams.orderNumber = filters.orderNumber;
    }

    try {
        const counts = await fetchRefundCounts(signal);
        const res = await httpClient.post(
            "/v1/api/customer-order/admin/refund-status",
            {
                pageNumber: pagination.page,
                pageSize: pagination.pageSize,
                sortBy: sorting.sortBy,
                sortOrder: sorting.sortOrder,
                filters: {}
            },
            {
                params: queryParams,
                signal
            }
        );

        return {
            ...res.data,
            counts: counts
        };
    } catch (error) {
        console.log("Error on fetching refunds", error);
        return Promise.reject(error);
    }
};

export const toggleRefundStatus = async ({ orderId, status }) => {
    try {
        await httpClient.put(`/v1/api/customer-order/update-order-status/${orderId}`, null, {
            params: {
                orderStatus: status,
                reason: ""
            }
        });
        return {
            orderId,
            status
        };
    } catch (error) {
        console.log("error on make as refunded", error);
        throw error;
    }
};
